function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypegoogleSizesWeightfilled = function SvgTypegoogleSizesWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#type=google,_size=s,_weight=filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.805 10.23c0-.68-.055-1.363-.172-2.032H10.2v3.851h5.402a4.63 4.63 0 0 1-2 3.039v2.499h3.223c1.893-1.742 2.98-4.314 2.98-7.357",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 20c2.697 0 4.971-.885 6.629-2.413l-3.223-2.5c-.896.61-2.054.956-3.402.956-2.61 0-4.821-1.76-5.615-4.126H1.264v2.576A10 10 0 0 0 10.2 20",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.586 11.917a6 6 0 0 1 0-3.829V5.512H1.264a10.01 10.01 0 0 0 0 8.98z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 3.958a5.43 5.43 0 0 1 3.836 1.5l2.855-2.856A9.6 9.6 0 0 0 10.2.001a10 10 0 0 0-8.936 5.511l3.321 2.576c.79-2.37 3.006-4.13 5.615-4.13",
    style: {
      fill: "#ea4335"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "type=google,_size=s,_weight=filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgTypegoogleSizesWeightfilled;